// Component.
import { ModalButton } from "./contactModal/ModalButton";
// Styles.
import { HeroSectionContainer } from "../styles/features/HeroSectionStyles";
import HeroImg from "../assets/computer.jpg";

export const HeroSection: React.FC = () => {
  return (
    <HeroSectionContainer className="hero-section">
      <div className="intro-section">
        <h1>
          ¿Quieres mejorar
          <br /> tu negocio?
        </h1>
        <h2>¡Creamos herramientas digitales para ti!</h2>
        <p>
          Facilitamos la gestión de tu negocio con una infrestructura eficiente
          para
          <br /> organizar tus inventarios. Además, mejoramos tu presencia
          digital <br /> mediante páginas web dinámicas e interactivas.
        </p>
        <ModalButton />
      </div>
      <div className="image-section">
        <img src={HeroImg} alt="Imagen de freepik" />
      </div>
    </HeroSectionContainer>
  );
};
